import React from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { useSignal } from "@preact/signals-react"
import { Alert, AlertTitle, Box, CircularProgress, Drawer, Typography } from "@mui/material"
import { ButtonLoadingSeeker, ImageSeeker, PasswordFieldSeeker, TextFieldSeeker } from "@ui-seeker/core"

import { HOME_ROUTES } from "@constants"
import { useUserApp } from "@hooks"
import { drawerStyles } from "./@styles"


export default function LoginPage() {
	const [searchParams] = useSearchParams()
	const { isLogged, checkingLogging, isLoadingLogin, handleLogin, error } = useUserApp(true)
	const username = useSignal('')
	const password = useSignal('')

	const redirect = searchParams.get('redirect')

	if (isLogged) {
		if (redirect) return <Navigate to={redirect} replace/>
		else return <Navigate to={HOME_ROUTES.HOME_PATH} replace/>
	}

	const handleClick = e => {
		e.preventDefault()
		handleLogin(username.value, password.value)
	}

	return <>
		<Box sx={{
			width: 0.7,
			height: '100vh',
			backgroundImage: "url('/resource/background-login.png')",
			backgroundSize: 'cover'
		}}/>

		<Box component="form">
			<Drawer PaperProps={{ sx: drawerStyles }} variant="permanent" anchor="right">

				<Box sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', mb: 4 }}>
					<ImageSeeker src="/resource/logo192.png" sx={{ width: '50px', mr: 2 }}/>
					<Typography variant="h2" sx={{ mr: 0.8 }}>Rent a car</Typography>
				</Box>

				<Typography variant="h4" sx={{ mb: 2.5 }}>
					User log in
				</Typography>

				{!!checkingLogging && <Box sx={{ width: '70%', textAlign: 'center' }}>
					<Typography sx={{ mb: 3, color: 'text.secondary' }}>
						Checking User Info
					</Typography>

					<CircularProgress size={60}/>
				</Box>}

				{!checkingLogging && <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: .6 }}>

					{!!error && <Alert severity="error">
						<AlertTitle>Login Error</AlertTitle>
						{error}
					</Alert>}

					<TextFieldSeeker
						label="Email"
						placehoder="Email"
						value={username.value}
						onChange={e => username.value = e.target.value}
						startIcon="envelope"
					/>

					<PasswordFieldSeeker
						value={password.value}
						onChange={e => password.value = e.target.value}
						startIcon="lock"
					/>

					<ButtonLoadingSeeker
						type="submit"
						loading={isLoadingLogin}
						onClick={handleClick}
					>
						Log in
					</ButtonLoadingSeeker>
				</Box>}

				<Box component="img"
					src="https://storage.googleapis.com/cdn.paraty.es/dataseekers/files/logo-data-simple.png"
					sx={{ position: 'absolute', bottom: 48, height: 28, left: '50%', transform: 'translateX(-50%)' }}
				/>
			</Drawer>
		</Box>
	</>
}